const ROUTE_STOP_DISTANCE_THRESHOLD = 0.01

export function getPlannerRouteBoundsCoordinates(route) {
  if (!route || !route.polyline || !route.polyline.geometry) { return null }

  return route.polyline.geometry.coordinates
}

export function filterPlannerStopsNearRoute(stops = [], routeCoordinates = []) {
  const routeCoords = routeCoordinates.map(([lng, lat]) => ({ lat, lng }))

  return stops.filter(stop =>
    routeCoords.some(coord =>
      Math.abs(stop.lat - coord.lat) < ROUTE_STOP_DISTANCE_THRESHOLD &&
      Math.abs(stop.lng - coord.lng) < ROUTE_STOP_DISTANCE_THRESHOLD
    )
  )
}

export function buildPlannerAdvancedRouteState(route, stops = []) {
  const boundsCoordinates = getPlannerRouteBoundsCoordinates(route)

  if (!boundsCoordinates) {
    return { showingRouteStops: false }
  }

  return {
    showingRouteStops: true,
    filteredStops: filterPlannerStopsNearRoute(stops, boundsCoordinates),
    boundsCoordinates
  }
}

export function buildPlannerStopLatLngEvent(stop) {
  return {
    latlng: {
      lat: stop.lat,
      lng: stop.lng
    }
  }
}

export function buildPlannerBikeTooltipState(stop, markerCoordinates) {
  return {
    tooltipPosition: {
      x: markerCoordinates.x,
      y: markerCoordinates.y
    },
    directionsStopsBike: stop.name,
    bikesAvailable: stop.bikesAvailable,
    spacesAvailableBike: stop.spacesAvailable,
    latStopBike: stop.lat,
    lonStopBike: stop.lng,
    tooltipVisible: true
  }
}

export function buildPlannerDirectionsSelectedState(direction, isOrigin) {
  if (direction === '') { return {} }

  return {
    directionsSelectedOrigin: isOrigin ? direction : '',
    directionsSelectedDestiny: isOrigin ? '' : direction,
    enableButtonSelect: true
  }
}

export function isPlannerMapClickActive(activePointsMap) {
  return !!(activePointsMap && activePointsMap.activePointsMap)
}

export function getPlannerMapClickCoordinates(event) {
  return event.latlng
}

export function buildPlannerCurrentMarkerIconConfig(iconUrl) {
  return {
    iconUrl,
    iconSize: [30, 30],
    iconAnchor: [16, 37]
  }
}

export function getPlannerStopDisplayAction(stop, selectedStopId) {
  if (!stop || typeof stop.lat === 'undefined' || typeof stop.lng === 'undefined') { return 'invalid' }
  if (selectedStopId === stop.id) { return 'toggle' }

  return stop.operator_type === 'bike' ? 'bike' : 'operator'
}

export function centerPlannerMapOnMarker(map, lat, lng) {
  return new Promise((resolve) => {
    const zoomLevel = map.getZoom()
    map.setView([lat, lng], zoomLevel, {
      animate: true,
      duration: 0.5
    })
    setTimeout(() => {
      resolve()
    }, 800)
  })
}
